import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import { FaPlus, FaMinus } from 'react-icons/fa';
import { event } from '@minerva-analytics/pantheon';

import signActions from 'store/sign/actions';
import timeframeActions from 'store/timeframe/actions';
import categoryActions from 'store/category/actions';

import capitalize from '../../oldpantheon/utils/capitalize';

import SvgAqarius from '../../assets/signs_line_symbols/aquarius';
import SvgAries from '../../assets/signs_line_symbols/aries';
import SvgCancer from '../../assets/signs_line_symbols/cancer';
import SvgCapricorn from '../../assets/signs_line_symbols/capricorn';
import SvgGemini from '../../assets/signs_line_symbols/gemini';
import SvgLeo from '../../assets/signs_line_symbols/leo';
import SvgLibra from '../../assets/signs_line_symbols/libra';
import SvgPisces from '../../assets/signs_line_symbols/pisces';
import SvgSagittarius from '../../assets/signs_line_symbols/sagittarius';
import SvgScorpio from '../../assets/signs_line_symbols/scorpio';
import SvgTaurus from '../../assets/signs_line_symbols/taurus';
import SvgVirgo from '../../assets/signs_line_symbols/virgo';

import SvgNaviconHoroscopes from '../../assets/navicon_horoscopes';


import {
  SignList,
  Link,
  HoroscopeTitle,
  HoroscopeIcon,
  AccordionTitleWrapper,
  SignLineIcon,
  SignWrapper,
} from './NavHoroscopeAccordion.styles';

const NAV_ROUTES = [
  {
    route: `/life/daily/aries`,
    text: `aries`,
    icon: <SvgAries />,
  },
  {
    route: `/life/daily/taurus`,
    text: `taurus`,
    icon: <SvgTaurus />,
  },
  {
    route: `/life/daily/gemini`,
    text: `gemini`,
    icon: <SvgGemini />,
  },
  {
    route: `/life/daily/cancer`,
    text: `cancer`,
    icon: <SvgCancer />,
  },
  {
    route: `/life/daily/leo`,
    text: `leo`,
    icon: <SvgLeo />,
  },
  {
    route: `/life/daily/virgo`,
    text: `virgo`,
    icon: <SvgVirgo />,
  },
  {
    route: `/life/daily/libra`,
    text: `libra`,
    icon: <SvgLibra />,
  },
  {
    route: `/life/daily/scorpio`,
    text: `scorpio`,
    icon: <SvgScorpio />,
  },
  {
    route: `/life/daily/sagittarius`,
    text: `sagittarius`,
    icon: <SvgSagittarius />,
  },
  {
    route: `/life/daily/capricorn`,
    text: `capricorn`,
    icon: <SvgCapricorn />,
  },
  {
    route: `/life/daily/aquarius`,
    text: `aquarius`,
    icon: <SvgAqarius />,
  },
  {
    route: `/life/daily/pisces`,
    text: `pisces`,
    icon: <SvgPisces />,
  },
];

const NavHoroscopeAccordion = (props) => {
  const [openSignList, setOpenSignList] = useState(false);

  const {
    location: { pathname },
  } = props.history;

  const onSignClick = (config) => {
    props.toggleNav();
    event([`click`, `nav-item`, `${config.text}-accordion-click`]);
    props.selectSign({ id: config.text });
    props.selectCategory({ id: `life` });
    props.selectTimeframe({ id: `daily` });
  };

  return (
    <>
      <AccordionTitleWrapper
        onClick={() => {
          setOpenSignList(!openSignList);
          event([`click`, `nav-item`, `horoscopes`]);
        }}
      >
        <HoroscopeTitle>
          <HoroscopeIcon><SvgNaviconHoroscopes /></HoroscopeIcon>
          Horoscopes
        </HoroscopeTitle>
        { openSignList ? <FaMinus /> : <FaPlus />}
      </AccordionTitleWrapper>
      <SignList openSignList={openSignList}>
        {NAV_ROUTES.map((config) => {
          const active = pathname === config.route;

          return (
            <Link
              active={active.toString()}
              to={config.route}
              key={config.text}
              onClick={() => onSignClick(config)}
            >
              <SignWrapper>
                <SignLineIcon>{config.icon}</SignLineIcon>
                {capitalize(config.text)}
              </SignWrapper>
            </Link>
          );
        })}
      </SignList>
    </>
  );
};

NavHoroscopeAccordion.propTypes = {
  selectSign: PropTypes.func.isRequired,
  selectTimeframe: PropTypes.func.isRequired,
  selectCategory: PropTypes.func.isRequired,
};

export default withRouter(connect(() => ({}), {
  selectSign: signActions.selectSign,
  selectTimeframe: timeframeActions.selectTimeframe,
  selectCategory: categoryActions.selectCategory,
})(NavHoroscopeAccordion));
